import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';

import { surfaceLabel } from '../spaces.utils';

/** A space's surfaces as quiet chips: the first few, then "+N". */
export function SurfaceList({ surfaces, max = 3 }: { surfaces?: string[]; max?: number }) {
    const { t } = useTranslation();
    if (!surfaces?.length) return <span className="text-muted-foreground">—</span>;
    return (
        <span className="flex flex-wrap gap-1">
            {surfaces.slice(0, max).map((surface) => (
                <Badge key={surface} variant="outline" className="font-normal text-muted-foreground">
                    {surfaceLabel(t, surface)}
                </Badge>
            ))}
            {surfaces.length > max && (
                <Badge variant="outline" className="font-normal text-muted-foreground tabular-nums">
                    +{surfaces.length - max}
                </Badge>
            )}
        </span>
    );
}
